<template>
  <Teleport to="body">
    <div
      v-if="content && position"
      class="pointer-events-none fixed z-[9999] w-80 rounded-lg border border-gray-200 bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-800"
      :style="{
        left: position.x + 'px',
        top: position.y + 'px',
        transform: getTransform(position)
      }"
    >
      <div class="flex gap-4">
        <div
          v-if="content.image && showImage"
          class="h-16 w-16 flex-shrink-0"
        >
          <img
            :src="content.image"
            :alt="content.headline"
            class="h-full w-full rounded-lg object-cover"
          >
        </div>
        <div class="flex-1">
          <h3 class="mb-2 text-base font-bold">
            {{ content.headline }}
          </h3>
          <div
            class="text-sm text-gray-600 dark:text-gray-300"
            v-html="content.description"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import type { TooltipContent, TooltipPosition } from '@/composables/useTooltip'

interface Props {
  content: TooltipContent | null
  position: TooltipPosition | null
  showImage?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showImage: false
})

function getTransform(pos: TooltipPosition): string {
  const translateX = pos.alignX === 'right'
    ? 'translateX(-100%) translateX(16px)'
    : pos.alignX === 'left'
      ? 'translateX(-16px)'
      : 'translateX(-50%)'
  const translateY = pos.placement === 'bottom'
    ? 'translateY(8px)'
    : 'translateY(-100%) translateY(-8px)'
  return `${translateX} ${translateY}`
}
</script>
